import * as React from 'react'
import { ScrollMenu, Props as ScrollMenuProps, VisibilityContext } from 'react-horizontal-scrolling-menu';

export type Props = {
	setContainerRef?: (ref: React.RefObject<HTMLElement>) => void
}

type scrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

function Arrow({
	children,
	disabled,
	onClick
}: {
	children: React.ReactNode;
	disabled: boolean;
	onClick: VoidFunction;
}) {
	return (
		<i 
			className="material-icons"
			onClick={onClick}
			style = {{
				cursor: "pointer",
				flexDirection: "column",
				justifyContent: "center",
				opacity: disabled ? "0.1" : "1",
				userSelect: "none",
				display: "flex",
				fontSize: "3rem",
				pointerEvents: disabled ? "none" : "all",
			}}
		>{children}</i>
	);
}

export function LeftArrow() {
	const {
		isFirstItemVisible,
		scrollPrev,
		items,
		initComplete
	} = React.useContext(VisibilityContext);

	const [disabled, setDisabled] = React.useState(
		!initComplete || !items.size || isFirstItemVisible
	);

	React.useEffect(() => {
		if (items.size) {
			setDisabled(!items.size || isFirstItemVisible);
		}
	}, [isFirstItemVisible, items]);

	return (
		<Arrow disabled={disabled} onClick={() => scrollPrev(null, 'center')}>
			navigate_before
		</Arrow>
	);
}

export function RightArrow() {
	const {
		isLastItemVisible,
		scrollNext,
		items,
		initComplete
	} = React.useContext(VisibilityContext);

	const [disabled, setDisabled] = React.useState(
		!initComplete || !items.size || isLastItemVisible
	);

	React.useEffect(() => {
		setDisabled(!items.size || isLastItemVisible);
	}, [isLastItemVisible, items]);

	return (
		<Arrow disabled={disabled} onClick={() => scrollNext(null, 'center')}>
			navigate_next
		</Arrow>
	);
}

export default class HorizontalScroll extends React.Component<Props & ScrollMenuProps> {
	private onInit = (apiObj: scrollVisibilityApiType): void => {
		if(this.props.setContainerRef) this.props.setContainerRef(apiObj.scrollContainer)
	}

	private onWheel = (apiObj: scrollVisibilityApiType, ev: React.WheelEvent): void => {
		const isTouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

		if (isTouchpad) {
			ev.stopPropagation();
			return;
		}

		if (ev.deltaY < 0) {
			apiObj.scrollPrev(null, 'center');
		} else if (ev.deltaY > 0) {
			apiObj.scrollNext(null, 'center');
		}
	}

	render = () => <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} onWheel={this.onWheel} onInit={this.onInit} {...this.props} />
}
